import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  /** Route to link back to; the back arrow only renders when set. */
  backTo?: string;
  backLabel?: string;
  className?: string;
  /** e.g. a `<ProvenanceBadge />` — rendered inline right after the title. */
  titleBadge?: ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  backTo,
  backLabel = "Back",
  className,
  titleBadge,
}: PageHeaderProps) {
  return (
    <div className={cn("mb-6", className)}>
      {backTo && (
        <Link
          to={backTo}
          className="text-wg-07 hover:text-jj-red mb-1 inline-flex items-center gap-2 text-sm font-semibold"
        >
          <ArrowLeft className="size-[15px]" strokeWidth={2.4} />
          {backLabel}
        </Link>
      )}
      <div className="flex flex-wrap items-center gap-2.5">
        <h2 className="font-heading text-wg-08 text-[25px] font-medium tracking-[-0.01em]">
          {title}
        </h2>
        {titleBadge}
      </div>
      {subtitle != null && <p className="text-wg-07 mt-1 max-w-[720px] text-[15px]">{subtitle}</p>}
    </div>
  );
}
